import { useQuery } from '@apollo/client';
import { GET_HOTEL_BY_SUBDOMAIN_QUERY } from '../infrastructure/graphql/getHotelBySubdomain.gql';
import {
  GetHotelBySubdomain,
  GetHotelBySubdomainVariables,
} from '../infrastructure/graphql/types/GetHotelBySubdomain';

interface QueryOptions {
  pollInterval?: number;
  skip?: boolean;
}

export function useGetHotelBySubdomain(
  { subdomain = '' }: Partial<GetHotelBySubdomainVariables>,
  options: QueryOptions = {}
) {
  const { data, ...rest } = useQuery<GetHotelBySubdomain, GetHotelBySubdomainVariables>(
    GET_HOTEL_BY_SUBDOMAIN_QUERY,
    {
      ...options,
      skip: options.skip ?? !subdomain,
      variables: {
        subdomain,
      },
    }
  );

  const hotel = data?.hotels?.[0];

  return { hotel, ...rest };
}
